import data from './blogEntry.json'

export default data
